document.body.addEventListener('change', (event) => 
{
   const target = event.target;
   const selector = 'select.view-all--regions-selector';
   const el = target.matches(selector) ? target : target.closest(selector) ? target.closest(selector) : null;
   if (el && target.value !== '')
   {
      window.location.href = target.value;
   }
});